import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { ListPlus, Plus } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "../../../i18n";
import { api } from "../../../lib/api";
import { useLists } from "../hooks";
import { Popover, PopoverContent, PopoverTrigger } from "../../../components/ui/popover";

export const AddToList = ({ itemCode, qty }) => {
  const { t } = useI18n();
  const qc = useQueryClient();
  const lists = useLists();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");

  const done = (list) => {
    qc.invalidateQueries({ queryKey: ["lists"] });
    toast.success(t("shop.addedToList", { name: list.name }));
    setOpen(false);
    setName("");
  };
  const addTo = async (list) => {
    try {
      const items = [...list.items.filter((i) => i.item_code !== itemCode), { item_code: itemCode, qty_boxes: qty }];
      done((await api.put(`/lists/${list.id}`, { name: list.name, items })).data);
    } catch (e) { toast.error(t("common.error")); }
  };
  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try { done((await api.post("/lists", { name, items: [{ item_code: itemCode, qty_boxes: qty }] })).data); } catch (err) { toast.error(t("common.error")); }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="add-to-list-button" aria-label={t("shop.addToList")} className="flex h-12 shrink-0 items-center gap-1.5 rounded-full border border-navy/15 px-4 text-sm font-semibold text-navy hover:bg-slate-50">
          <ListPlus className="h-4 w-4" /><span className="hidden sm:inline">{t("shop.addToList")}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 p-2" data-testid="add-to-list-popover">
        <ul className="max-h-56 overflow-y-auto">
          {(lists.data || []).map((l) => (
            <li key={l.id}><button type="button" onClick={() => addTo(l)} data-testid={`add-to-list-${l.id}`} className="flex h-11 w-full items-center justify-between rounded-lg px-3 text-left text-sm text-navy hover:bg-slate-50"><span className="truncate">{l.name}</span><span className="text-xs text-slate-400">{l.items.length}</span></button></li>
          ))}
        </ul>
        <form onSubmit={create} className="mt-1 flex gap-1 border-t border-slate-100 pt-2">
          <input value={name} onChange={(e) => setName(e.target.value)} maxLength={60} placeholder={t("shop.newList")} data-testid="new-list-name-input" className="h-11 min-w-0 flex-1 rounded-lg border border-slate-200 px-3 text-sm outline-none focus:border-brand" />
          <button type="submit" data-testid="new-list-create-button" aria-label={t("shop.create")} className="grid h-11 w-11 place-items-center rounded-lg bg-brand text-white"><Plus className="h-4 w-4" /></button>
        </form>
      </PopoverContent>
    </Popover>
  );
};
